import apiService from 'src/shared/config/apiService';
import { UploadedFile } from 'src/shared/types/uploadedFile';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type ConversationTurn = {
  id: string;
  text: string;
  turn_type: string;
  conversation_id: string | null;
  created_at: string;
  files: UploadedFile[];
};

export type ConversationHistoryResponse = {
  turns: ConversationTurn[];
};

const getConversationHistory = async (
  rfqId: number
): Promise<ConversationHistoryResponse> => {
  try {
    const response = await apiService.get<ConversationHistoryResponse>(
      `/rfq/${rfqId}/conversation/`
    );

    return response.data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};

export default getConversationHistory;
